export const getSubdomain = () => {
  const host = window.location.hostname;
  const port = window.location.port;
  const parts = host.split(".");
  if (parts.length > 2) {
    return parts[0];
  }
  if (host === "localhost") {
    return `localhost_${port}`;
  }
  return "default";
};

export const getStorageKey = (key) => {
  return `${getSubdomain()}_${key}`;
};
